export const isBrowser = () => typeof window !== "undefined";

// @zapier/upsells@5.0.1 (c64b11b3c)
